export enum ChangingDirectionType {
    Previous = 1,
    Next = 2
}